import { Injectable } from '@angular/core';

interface Contacto{
  item: number,
  nombre: string,
  telefono: string,
  correo: string,
  cargo: string
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  public tableData: Contacto [] = []
  constructor() { }

  getTableData(){
    return this.tableData;
  }

  setTableData(data:Contacto[]){
    this.tableData = data;
  }
}
